module.exports = __webpack_public_path__ + "img/Group 285one2.454055fd.svg";